import * as React from "react";
import { Select } from "antd";
import styled from "styled-components";
import { Popconfirm } from "antd";

import TextBox from "../TextBox";
import Selectbox from "../Selectbox";
import Error from "../Error";
import Form from "../Form";

import { objectSelector } from "theme/utils";

const {
  DIRECTORY_THEME
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const $STP = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/product`);
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const $ST = DIRECTORY_THEME.ADDRESS_FORM;
const { Option } = Select;

const DeleteButton = styled.button`
  color: red;
`;

const phoneFormats = {
  default: [
    "0",
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  TFS: [
    "0",
    "0",
    "3",
    "2",
    " ",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/
  ]
};
export default class AddressForm extends Form {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      countries: ["TFS"].includes($A.BRAND) && this.initCountries(),
      cities: !["TFS"].includes($A.BRAND) ? this.initCities() : [],
      townships: [],
      districts: [],
      address: null
    };
    this.submitForm = this.submitForm.bind(this);
  }

  initCountries = () => {
    const { countries } = this.props;

    if (!countries.length) return [];
    return countries.map((country) => ({
      label: country.name,
      value: country.pk
    }));
  };

  initCities = () => {
    const { cities } = this.props;
    if (!cities.length) return [];
    return cities.map((city) => ({ label: city.name, value: city.pk }));
  };

  componentDidMount() {
    const {
      fetchCities,
      fetchTownships,
      fetchDistricts,
      customer,
      address,
      cities,
      countries
    } = this.props;
    let cityPk = null;
    let countryPk = null;

    if (["TFS"].includes($A.BRAND)) {
      if (address && address.country && address.country.pk) {
        countryPk = address.country.pk;
      } else if (countries && countries.length > 0) {
        countryPk = countries[0].pk;
      }

      if (countryPk && address && address.city && address.city.name) {
        fetchCities(countryPk, address.city.name);
      }
    }

    if (address && address.city && address.city.pk) {
      cityPk = address.city.pk;
    } else if (cities.length > 0) {
      cityPk = cities[0].pk;
    }

    if (cityPk) {
      fetchTownships(cityPk);
    }

    if (address && address.township && address.pk) {
      fetchDistricts(address.township.pk);
    }

    this.initFormData({
      title: (address && address.title) || "",
      first_name: (address && address.first_name) || customer.first_name || "",
      last_name: (address && address.last_name) || customer.last_name || "",
      line: (address && address.line) || "",
      linePart1:
        address && address.line ? address.line.split($ST.SEPERATOR)[0] : "",
      linePart2:
        address && address.line ? address.line.split($ST.SEPERATOR)[1] : "",
      phone_number: (address && address.phone_number) || "",
      country: (address && address.country && address.country.pk) || "",
      city:
        (address && address.city && address.city.pk) ||
        (cities.length && cities[0].pk) ||
        "",
      township: (address && address.township && address.township.pk) || "",
      district: (address && address.district && address.district.pk) || "",
      postcode: (address && address.postcode) || "",
      type:
        this.props.address && this.props.address.is_corporate
          ? "company"
          : "individual",
      identity_number:
        (this.props.address && this.props.address.identity_number) || null,
      company_name:
        (this.props.address && this.props.address.company_name) || "",
      tax_no: (this.props.address && this.props.address.tax_no) || "",
      tax_office: (this.props.address && this.props.address.tax_office) || ""
    });
  }

  componentWillReceiveProps(nextProps) {
    const { cities, townships, districts } = nextProps;
    let transformedCities = cities;
    if (cities.length > 0) {
      transformedCities = cities.map((city) => {
        return {
          label: city.name,
          value: city.pk
        };
      });

      this.setField("country", cities[0].country);
    }
    this.setState({
      cities: [...transformedCities]
    });

    let transformedTownships = townships;
    if (townships.length > 0) {
      transformedTownships = townships.map((township) => {
        return {
          label: township.name,
          value: township.pk
        };
      });
    }
    this.setState({
      townships: [...transformedTownships]
    });

    let transformedDistricts = districts;
    if (districts.length > 0) {
      transformedDistricts = districts.map((district) => {
        return {
          label: district.name,
          value: district.pk
        };
      });
    }
    this.setState({
      districts: [...transformedDistricts]
    });
  }

  submitForm(event) {
    event.preventDefault();
    const { address } = this.props;

    const newFormData = {
      ...this.state.formData
    };

    if (["TFS"].includes($A.BRAND)) {
      newFormData["line"] =
        this.state.formData.linePart1 +
        $ST.SEPERATOR +
        this.state.formData.linePart2;
      newFormData["postcode"] = this.state.formData.city;
      delete newFormData["linePart1"];
      delete newFormData["linePart2"];
    }

    if (
      ["GAP"].includes($A.BRAND) &&
      (Boolean(newFormData.identity_number) ||
        (typeof newFormData.identity_number === "string" &&
          newFormData.identity_number.trim().length === 0))
    ) {
      delete newFormData["identity_number"];
    }

    this.props.submitAddress(newFormData, address && address.pk);
  }

  deleteAddress = (pk) => {
    this.props.onDeleteAddress(pk);
  };

  selectOptionRenderer = (items) => {
    return items.map((item) => (
      <Option value={item.value} key={item.value}>
        {" "}
        {item.label}{" "}
      </Option>
    ));
  };

  onCountrySearch = (val) => {
    this.setState({ countrySearch: val });
  };

  onCitySearch = (value) => {
    this.setState({ citySearch: value });

    const countryPk = this.state.formData.country;
    if (countryPk && value.length >= 2) {
      this.props.fetchCities(countryPk, value);
    }
  };

  onDistrictSearch = (val) => {
    this.setState({ districtSearch: val });
  };

  render() {
    const { pending, fetchDistricts, error, address, onDeleteAddress } =
      this.props;
    const { cities, townships, countries } = this.state;

    return (
      <div className="container address-form">
        <div className="row">
          <div className="col-12">
            <form onSubmit={this.submitForm}>
              <div className="row">
                <div className="col-12">
                  <h3 className="form-title-hero">{$ST.NEW_ADDRESS}</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <label className="individual">
                    <input
                      className="input-individual"
                      type="radio"
                      name="type"
                      value="individual"
                      onChange={(e) => this.setField("type", e.target.value)}
                      checked={this.state.formData.type === "individual"}
                    />
                    {$ST.INVIDIUAL}
                  </label>
                  {!["TFS"].includes($A.BRAND) && (
                    <label>
                      <input
                        className="input-individual"
                        type="radio"
                        name="type"
                        value="company"
                        onChange={(e) => this.setField("type", e.target.value)}
                        checked={this.state.formData.type === "company"}
                      />
                      {$ST.CORPORATE}
                    </label>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="input-margin">
                    <p className="form-label-title">
                      {$ST.ADDRESS_TITLE}
                      {!["TFS"].includes($A.BRAND) && " *"}
                    </p>
                    <TextBox
                      name="title"
                      type="text"
                      placeholder={objectSelector(
                        $ST,
                        "ADDRESS_TITLE_PLACEHOLDER",
                        ""
                      )}
                      value={this.state.formData.title}
                      onChange={(value) => this.setField("title", value)}
                    />
                    <Error data={error} field="title" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="input-margin">
                    <p className="form-label-title">{$ST.NAME} *</p>
                    <TextBox
                      name="first_name"
                      type="text"
                      onChange={(value) => this.setField("first_name", value)}
                      value={this.state.formData.first_name}
                    />
                    <Error data={error} field="first_name" />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <div className="input-margin">
                    <p className="form-label-title">{$ST.SURNAME} *</p>
                    <TextBox
                      name="last_name"
                      type="text"
                      onChange={(value) => this.setField("last_name", value)}
                      value={this.state.formData.last_name}
                    />
                    <Error data={error} field="last_name" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-12">
                  <div className="input-margin">
                    <p className="form-label-title">{$ST.PHONE_NUMBER} *</p>
                    <TextBox
                      name="phone_number"
                      masked={true}
                      mask={
                        $A.BRAND && phoneFormats[$A.BRAND]
                          ? phoneFormats[$A.BRAND]
                          : phoneFormats.default
                      }
                      type="text"
                      value={this.state.formData.phone_number}
                      onChange={(value) => this.setField("phone_number", value)}
                    />
                    <Error data={error} field="phone_number" />
                  </div>
                </div>
              </div>
              <div className="row">
                {["TFS"].includes($A.BRAND) && (
                  <div className="col-xs-12 col-sm-12">
                    <div className="input-margin">
                      <p className="form-label-title">{$ST.COUNTRY} *</p>
                      <Select
                        showSearch={true}
                        className="country-select"
                        name="country"
                        allowClear={true}
                        placeholder={$STP.CHOOSE}
                        value={this.state.formData.country}
                        optionFilterProp="children"
                        onSearch={this.onCountrySearch}
                        onChange={(value) => {
                          this.setField("country", value);
                          this.setField("city", "");
                          this.setField("township", "");
                          this.setField("district", "");

                          if (
                            this.state.citySearch &&
                            this.state.citySearch.length >= 2
                          ) {
                            this.props.fetchCities(
                              value,
                              this.state.citySearch
                            );
                          }
                        }}
                        onSelect={() => this.setState({ countrySearch: "" })}
                      >
                        {this.selectOptionRenderer(countries)}
                      </Select>
                      <Error data={error} field="country" />
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="input-margin">
                    <p className="form-label-title">{$ST.CITY} *</p>
                    <Select
                      showSearch={["TFS"].includes($A.BRAND)}
                      className="city-select"
                      name="city"
                      allowClear={true}
                      placeholder={$STP.CHOOSE}
                      value={this.state.formData.city}
                      optionFilterProp="children"
                      onSearch={this.onCitySearch}
                      onChange={(value) => {
                        this.setField("city", value);
                        this.setField("township", "");
                        this.setField("district", "");
                        this.props.fetchTownships(value);
                      }}
                      onSelect={() => this.setState({ citySearch: "" })}
                    >
                      {["TFS"].includes($A.BRAND) &&
                        ((Boolean(this.state.citySearch) &&
                          this.state.citySearch.length >= 2) ||
                          Boolean(this.state.formData.city)) &&
                        this.selectOptionRenderer(cities)}
                      {!["TFS"].includes($A.BRAND) &&
                        this.selectOptionRenderer(cities)}
                    </Select>
                    <Error data={error} field="city" />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <div className="input-margin">
                    <p className="form-label-title">{$ST.DISTRICT} *</p>
                    <Select
                      className="township-select"
                      allowClear={true}
                      placeholder={$STP.CHOOSE}
                      value={this.state.formData.township}
                      optionFilterProp="children"
                      onChange={(value) => {
                        this.setField("township", value);
                        fetchDistricts(value);
                      }}
                    >
                      {this.selectOptionRenderer(townships)}
                    </Select>
                    <Error data={error} field="township" />
                  </div>
                </div>
              </div>
              {Boolean(this.state.formData.township) &&
                this.state.districts.length !== 0 && (
                  <div className="row">
                    <div className="col-xs-12 col-sm-12">
                      <div className="input-margin">
                        <p className="form-label-title">{$ST.NEIGBORHOOD} *</p>
                        {["TFS"].includes($A.BRAND) ? (
                          <Select
                            showSearch
                            className="district-select"
                            name="district"
                            allowClear={true}
                            placeholder={$STP.CHOOSE}
                            value={this.state.formData.district}
                            optionFilterProp="children"
                            onSearch={this.onDistrictSearch}
                            onChange={(value) => {
                              this.setField("district", value);
                            }}
                            onSelect={() =>
                              this.setState({ districtSearch: "" })
                            }
                          >
                            {this.selectOptionRenderer(this.state.districts)}
                          </Select>
                        ) : (
                          <Selectbox
                            name="district"
                            icon="oksag"
                            value={this.state.formData.district}
                            options={this.state.districts}
                            onChange={(value) =>
                              this.setField("district", value)
                            }
                          />
                        )}
                        <Error data={error} field="district" />
                      </div>
                    </div>
                  </div>
                )}
              {["TFS"].includes($A.BRAND) ? (
                <React.Fragment>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <div className="input-margin">
                        <p className="form-label-title">{$ST.HOUSENUMBER} *</p>
                        <TextBox
                          name="line"
                          type="number"
                          onChange={(value) =>
                            this.setField("linePart1", value.slice(0, 4))
                          }
                          value={this.state.formData.linePart1}
                        />
                        <Error data={error} field="line" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="input-margin">
                        <p className="form-label-title">{$ST.MAILBOX}</p>
                        <TextBox
                          name="line"
                          type="text"
                          onChange={(value) =>
                            this.setField("linePart2", value.slice(0, 4))
                          }
                          value={this.state.formData.linePart2}
                        />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <div className="row">
                  <div className="col-xs-12 col-sm-12">
                    <div className="input-margin">
                      <p className="form-label-title">{$ST.ADDRESS} *</p>
                      <TextBox
                        name="line"
                        type="text"
                        onChange={(value) => this.setField("line", value)}
                        value={this.state.formData.line}
                      />
                      <Error data={error} field="line" />
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                {!["TFS"].includes($A.BRAND) && (
                  <div className="col-xs-12 col-sm-6">
                    <p className="form-label-title">{$ST.POST_CODE}</p>
                    <TextBox
                      masked={true}
                      mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/]}
                      name="postcode"
                      type="text"
                      onChange={(value) => this.setField("postcode", value)}
                      value={this.state.formData.postcode}
                    />
                    <Error data={error} field="postcode" />
                  </div>
                )}
                {["SAMSUNG", "Samsung-b2b", "Samsung-tec"].includes(
                  $A.BRAND
                ) && (
                  <div className="col-xs-12 col-sm-6">
                    <p className="form-label-title">
                      {$A.BRAND === "TFS" ? "Identity Number *" : "TCKN *"}
                    </p>
                    <TextBox
                      masked={true}
                      mask={[
                        /[1-9]/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      name="identity_number"
                      type="text"
                      onChange={(value) =>
                        this.setField("identity_number", value)
                      }
                      value={this.state.formData.identity_number}
                    />
                    <Error data={error} field="identity_number" />
                  </div>
                )}
              </div>

              {this.state.formData.type === "company" && (
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <div className="input-margin">
                      <p className="form-label-title">{$ST.COMPANY_NAME} *</p>
                      <TextBox
                        name="line"
                        type="text"
                        onChange={(value) =>
                          this.setField("company_name", value)
                        }
                        value={this.state.formData.company_name}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <div className="input-margin">
                      <p className="form-label-title">{$ST.TAX_NUMBER} *</p>
                      <TextBox
                        name="line"
                        type="text"
                        masked
                        mask={[
                          /[0-9]/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ]}
                        onChange={(value) => this.setField("tax_no", value)}
                        value={this.state.formData.tax_no}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <div className="input-margin">
                      <p className="form-label-title">{$ST.TAX_OFFICE} *</p>
                      <TextBox
                        name="line"
                        type="text"
                        onChange={(value) => this.setField("tax_office", value)}
                        value={this.state.formData.tax_office}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row btn-wrapper">
                <button
                  type="submit"
                  className="button pointer"
                  disabled={pending}
                >
                  {$ST.SAVE}
                </button>
                {address && address.pk && (
                  <Popconfirm
                    title="Are you sure, you want to delete ?"
                    onConfirm={() => onDeleteAddress(address.pk)}
                  >
                    <DeleteButton className="button pointer" disabled={pending}>
                      DELETE
                    </DeleteButton>
                  </Popconfirm>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/AddressForm.js